import { z } from 'zod';

export const invoiceTagSchema = z.enum(['advance_payment']);
export type InvoiceTag = z.infer<typeof invoiceTagSchema>;
